import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import { DatePicker } from "rsuite";
import "rsuite/DatePicker/styles/index.css";
import { Box } from "@mui/material";

dayjs.extend(isBetween);
dayjs.extend(isoWeek);

const formatWeekRange = (date) => {
  if (!date || !dayjs(date).isValid()) return "";
  const start = dayjs(date).startOf("isoWeek");
  const end = dayjs(date).endOf("isoWeek");
  return `${start.format("DD MMM YYYY")} - ${end.format("DD MMM YYYY")}`;
};

export default function WeekPickerPopover({ onWeekSelect, value }) {
  const [selectedDate, setSelectedDate] = useState(
    value?.startDate ? dayjs(value.startDate).toDate() : null
  );

  useEffect(() => {
    if (value?.startDate) {
      setSelectedDate(dayjs(value.startDate).toDate());
    }
  }, [value]);

  const handleChange = (date) => {
    if (!date || !dayjs(date).isValid()) return;

    const weekStart = dayjs(date).startOf("isoWeek");
    const weekEnd = dayjs(date).endOf("isoWeek");

    setSelectedDate(weekStart.toDate());

    onWeekSelect?.({
      startDate: weekStart.toDate(),
      endDate: weekEnd.toDate(),
    });
  };

  const handleClean = () => {
    setSelectedDate(null);
    onWeekSelect?.(null);
  };

  return (
    <Box>
      <DatePicker
        value={selectedDate}
        onChange={handleChange}
        isoWeek
        oneTap
        format="yyyy-MM-dd"
        placeholder="Select a week"
        cleanable
        style={{ width: "100%" }}
        onClean={handleClean}
        renderValue={(value) => formatWeekRange(value)}
        renderCell={(date) => {
          if (!selectedDate || !dayjs(date).isValid()) {
            return <div>{dayjs(date).date()}</div>;
          }

          const start = dayjs(selectedDate).startOf("isoWeek");
          const end = dayjs(selectedDate).endOf("isoWeek");
          const isInRange = dayjs(date).isBetween(start, end, "day", "[]");

          return (
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: isInRange ? "#1976d2" : undefined,
                color: isInRange ? "#fff" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {dayjs(date).date()}
            </div>
          );
        }}
      />
    </Box>
  );
}
